import { HttpService } from '@utils/services/http.service';
import { UrlService } from '@utils/services/url-service.service';
import { inject, Injectable } from '@angular/core';
import { ApiModuleEnum } from '@utils/interfaces/api-module.constant';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {

  private readonly _http = inject(HttpService);
  private readonly _urlService = inject(UrlService);
  private readonly URL = this._urlService.getEndpointUrl(
    { module: ApiModuleEnum.BASE, version: 'v1', path: 'refresh_token' });

  public updatePartial(id: string, body: Record<string, unknown>) {
    return this._http.updatePartial<Record<string, unknown>, void>(this.URL, id, body);
  }
}
